import React from "react";
import VisitorCard from "../components/VisitorCard";

const VisitorSearchResult: React.FC<JQI.PeopleSearchResultProps> = (props) => {
  const { filters, ...otherProps } = props;

  return <VisitorCard {...otherProps} />
}

export default VisitorSearchResult;